import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card } from "react-md";

import ReactWeather from "react-open-weather";
//Optional include of the default css styles
import "react-open-weather/lib/css/ReactWeather.css";

export default class Inbox extends Component {
  static propTypes = {
    prop: PropTypes
  };

  //TO DO create a forecast prediction for the weather and rain that displays the
  //expected volume in the tank to be harvested in the next 6 days

  // http://api.openweathermap.org/data/2.5/forecast?&appid=8103d236f2747f1d4d5646cc779dd91e&cnt=5&lang=en&units=imperial&q=Bermuda
  componentWillMount = () => {};

  render() {
    return (
      <div style={{ paddingTop: "10px", color: "white" }}>
        <Card
          className="md-cell md-cell--12 md-text-container h1"
          style={{ borderRadius: "5px" }}
        >
          <ReactWeather
            forecast="5days"
            unit="imperial"
            apikey="8103d236f2747f1d4d5646cc779dd91e"
            type="geo"
            lat="32.3"
            lon="-64.75"
          />
        </Card>
      </div>
    );
  }
}
